var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "drawer pt-2",
          attrs: { value: true, floating: "", app: "" }
        },
        [
          _c(
            "v-list",
            { attrs: { nav: "", dense: "" } },
            [
              _c(
                "v-list-item-group",
                { attrs: { "active-class": "primary--text text--accent-4" } },
                [
                  _c(
                    "v-list-item",
                    { attrs: { to: _vm.homeLink } },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icons.home))])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [_vm._v("Home")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/users" } },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icons.users))])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [_vm._v("Explore users")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }